export default __webpack_public_path__ + "static/media/sgd-13.c5b226b1.png";